import { Controller } from "@hotwired/stimulus"
import "whatwg-fetch"

export default class extends Controller {
  static targets = ["form", "inputs", "loading", "error", "lat", "lng", "accuracy"]

  connect() {
    console.log("Initialized location controller")
  }

  useCurrentLocation = (e) => {
    e.preventDefault()
    Turbo.cache.clear()
    if (this.hasInputsTarget) {
      this.inputsTarget.style.display = "none"
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = ""
    }
    if (this.hasErrorTarget) {
      this.errorTarget.style.display = "none"
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log("current position", position)
        this.latTarget.value = position.coords.latitude
        this.lngTarget.value = position.coords.longitude
        this.accuracyTarget.value = position.coords.accuracy
        this.formTarget.submit()
      },
      (err) => {
        console.log("Could not get location", err)
        if (this.hasInputsTarget) {
          this.inputsTarget.style.display = ""
        }
        if (this.hasLoadingTarget) {
          this.loadingTarget.style.display = "none"
        }
        if (this.hasErrorTarget) {
          this.errorTarget.style.display = ""
          this.errorTarget.innerHTML = "Could not determine current location"
        }
      },
      {
        enableHighAccuracy: false,
        timeout: 15000,
        maximumAge: 1000 * 60 * 60
      }
    )
  }
}
